import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TagModel, TagSelectorOutput } from '../../../models/tag.model';
import { fieldRequired } from '../../../utils/form.utils';

@Component({
  selector: 'app-tag-selection-dialog',
  templateUrl: './tag-selection-dialog.component.html',
  styleUrl: './tag-selection-dialog.component.scss',
  standalone: false,
})
export class TagSelectionDialogComponent {
  title: string = 'Tag zuweisen';
  description: string =
    'Bitte weise der Datei mindestens einen Tag zu, bevor du sie hochlädst.';
  selectedTags: TagModel[] = [];
  enableLinkInput: boolean = false;

  tagSelectionForm: FormGroup = new FormGroup({
    tags: new FormControl([], Validators.required),
    linkTitle: new FormControl({ value: '', disabled: true }),
    linkUrl: new FormControl({ value: '', disabled: true }),
  });

  fieldRequired = fieldRequired;

  constructor(
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    if (this.config.data) {
      this.title = this.config.data.title || this.title;
      this.description = this.config.data.description || this.description;
      this.selectedTags = this.config.data.tags || [];
      this.tagSelectionForm.patchValue({ tags: this.selectedTags });

      this.enableLinkInput = this.config.data.enableLinkInput || false;

      if (this.enableLinkInput) {
        this.enableLinkControls();
        this.description =
          'Bitte weise dem Link mindestens einen Tag zu, bevor du ihn speicherst.';
      }
    }
  }

  selectedTagsChange(tags: TagModel[]) {
    this.tagSelectionForm.patchValue({ tags });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  saveTags() {
    if (!this.tagSelectionForm.valid) {
      console.error('Form is invalid');
      return;
    }

    const tagSelectorOutput: TagSelectorOutput = {
      tags: this.tagSelectionForm.value.tags,
      link: {
        title: this.tagSelectionForm.value.linkTitle,
        url: this.tagSelectionForm.value.linkUrl,
      },
    };

    this.dialogRef.close(tagSelectorOutput);
  }

  private enableLinkControls() {
    this.tagSelectionForm.controls['linkUrl'].enable();
    this.tagSelectionForm.controls['linkTitle'].enable();
    this.tagSelectionForm.controls['linkUrl'].setValidators([
      Validators.required,
      Validators.pattern('https?://.+'),
      Validators.maxLength(2000),
    ]);
    this.tagSelectionForm.controls['linkTitle'].setValidators([
      Validators.required,
      Validators.maxLength(255),
    ]);
    this.tagSelectionForm.updateValueAndValidity();
  }
}
